/* Multi-image hover playback for custom product card cards. */
(() => {
  if (customElements.get('custom-product-card')) return;

  customElements.define('custom-product-card', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.images = [...this.querySelectorAll('.custom-product-card__image')];
      this.index = 0;
      this.playing = false;
      this.runId = 0;
      this.speed = Math.max(500, Number(this.dataset.duration) || 2000);
      this.style.setProperty('--custom-card-cycle-duration', (this.images.length * this.speed) + 'ms');
      this.images.forEach((img, i) => { img.dataset.active = i === 0 ? 'true' : 'false'; });

      this.enter = event => {
        if (event && event.pointerType === 'touch') return;
        if (!window.matchMedia('(hover: hover)').matches) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.start();
      };
      this.leave = () => this.stop();
      this.focusIn = () => {
        if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) this.start();
      };
      this.focusOut = event => {
        if (!this.contains(event.relatedTarget)) this.stop();
      };
      this.hide = () => {
        if (document.hidden) this.stop();
      };
      this.addEventListener('pointerenter', this.enter);
      this.addEventListener('pointerleave', this.leave);
      this.addEventListener('focusin', this.focusIn);
      this.addEventListener('focusout', this.focusOut);
      document.addEventListener('visibilitychange', this.hide);
    }

    prepare(index) {
      const img = this.images[index];
      if (!img) return;
      const source = img.dataset.cardSrc;
      if (source) {
        img.loading = 'eager';
        img.src = source;
        delete img.dataset.cardSrc;
      }
    }

    start() {
      if (this.dataset.hoverEnabled !== 'true' || this.playing || this.images.length < 2) return;
      this.playing = true;
      this.runId += 1;
      this.dataset.playing = 'true';
      this.index = 0;
      this.images.forEach((img, i) => { img.dataset.active = i === 0 ? 'true' : 'false'; });
      this.prepare(1);
      this.schedule();
    }

    schedule() {
      clearTimeout(this.timer);
      if (this.playing) this.timer = setTimeout(() => this.advance(), this.speed);
    }

    advance() {
      if (!this.playing || !this.isConnected) return;
      const runId = this.runId;
      const next = (this.index + 1) % this.images.length;
      this.prepare(next);
      const img = this.images[next];
      const update = () => {
        if (!this.playing || !this.isConnected || this.runId !== runId) return;
        this.index = next;
        this.images.forEach((image, i) => { image.dataset.active = i === next ? 'true' : 'false'; });
        this.prepare((next + 1) % this.images.length);
        this.schedule();
      };
      if (img.complete && img.naturalWidth > 0) {
        update();
      } else if (img.complete && img.naturalWidth === 0) {
        this.stop();
      } else {
        img.addEventListener('load', update, { once: true });
        img.addEventListener('error', () => this.stop(), { once: true });
      }
    }

    stop() {
      this.runId = (this.runId || 0) + 1;
      this.playing = false;
      clearTimeout(this.timer);
      this.dataset.playing = 'false';
      this.index = 0;
      this.images.forEach((img, i) => { img.dataset.active = i === 0 ? 'true' : 'false'; });
    }

    disconnectedCallback() {
      this.stop();
      this.removeEventListener('pointerenter', this.enter);
      this.removeEventListener('pointerleave', this.leave);
      this.removeEventListener('focusin', this.focusIn);
      this.removeEventListener('focusout', this.focusOut);
      document.removeEventListener('visibilitychange', this.hide);
      this.initialized = false;
    }
  });
})();
